import { AbstractCanvas, AbstractCanvasProps } from './abstractcanvas.tsx';
import { ColourChallengeData } from './colourchallenge.tsx';

class ColourChallengeCanvas extends AbstractCanvas<ColourChallengeData> {
  constructor(props: AbstractCanvasProps<ColourChallengeData>) {
      super(props)
      this.draw=this.draw.bind(this) 
    }
      
      drawCircle(context: CanvasRenderingContext2D, startX: number, startY: number, circleSize: number, circleColour: string){
        context.beginPath();
        context.arc(startX, startY, circleSize, 0, Math.PI*2, true);
        context.fillStyle = circleColour;
        context.fill();
        context.beginPath();
        context.arc(startX, startY, circleSize, 0, Math.PI*2, true);
        context.lineWidth = 3;
        context.stroke();
      }
       
      drawAllCircles(context: CanvasRenderingContext2D, colors: string[]){
        let colourscheme = colors;
        let size=500;
        let circleSize = 75;
        let gapSize = 25;
        let initX = circleSize*2;
        
        if(colors.length === 5){
          let startX = initX;
          let startY = 220;
          let x = 0;
          console.log("Drawing "+colors.length +" circles");
          for(let i=0; i<colors.length; i++){
            console.log("Drawing Circle "+(i+1)+" colour: "+ colourscheme[x])
            this.drawCircle(context, startX, startY, circleSize, colourscheme[x]);
            startX = startX+circleSize*2+gapSize;
          
            if(i===2){
              startY= startY+(circleSize*2)+gapSize;
              startX = (circleSize*3)+gapSize;
            }
            x++;
          }
        }
        else if (colors.length === 3){
          let startX = 325;
          let startY = 250;
          let sideLength = 250;
          circleSize = 100;
          console.log("Drawing "+colors.length +" circles");
          console.log("Drawing Circle 1 colour: "+ colourscheme[0])
          console.log("Drawing Circle 2 colour: "+ colourscheme[1])
          console.log("Drawing Circle 3 colour: "+ colourscheme[2])
          this.drawCircle(context, startX - sideLength / 2, startY + sideLength * Math.sqrt(3)/2, circleSize, colourscheme[0]);
          this.drawCircle(context, startX, startY, circleSize, colourscheme[1]);
          this.drawCircle(context, startX + sideLength / 2, startY + sideLength * Math.sqrt(3)/2, circleSize, colourscheme[2]);
        }
        else {
          circleSize = 100;
          initX = size/2 - circleSize/2 + gapSize/2;
          let startX = initX;
          let startY = 250;
          let colourscheme = colors;
          console.log("Drawing "+colors.length +" circles");

          for(let i= 0; i<colors.length; i++){
            console.log("Drawing Circle "+(i+1)+" colour: "+ colourscheme[i])

            this.drawCircle(context, startX, startY, circleSize, colourscheme[i]);
            startX = startX+circleSize*2+gapSize
            if(i===1){
              startY = startY+(circleSize*2)+gapSize;
              startX = initX
            }
          }
        }
         context.fillStyle = "black";
      }

  draw() {
    
    const canvas = this.canvasRef.current
    if (canvas === null) {
      return;
    }
    const context = canvas.getContext('2d')
    if (context === null) {
      return;
    }
    const outputImage = this.imageRef.current
    if (outputImage === null) {
      return;
    }
    //Our first draw
    context.font = "bold 30px Courier New";

     let fontsize = 100
     let size=500


    context.font = "bold "+fontsize+"px Courier New";
   let squaresize = size; 
    context.canvas.width = squaresize+150
    context.canvas.height = squaresize+150

    //draw white background
    context.fillStyle = '#ffffff'
    context.fillRect(0, 0, context.canvas.width, context.canvas.height)
    context.fillStyle = '#000000'

    this.drawAllCircles(context, this.props.currentChallengeData.colors);


    //draw green border
    context.beginPath();
    context.moveTo(0, 0);
    context.lineTo(0,context.canvas.height);
    context.lineTo(context.canvas.width, context.canvas.height);
    context.lineTo(context.canvas.width,0);
    context.lineTo(0,0)
    context.lineWidth = 40;
    context.strokeStyle = "#84E095"
    context.stroke()

    //draw pink border
    context.beginPath();
    context.moveTo(0, 0);
    context.lineTo(0,context.canvas.height);
    context.lineTo(context.canvas.width, context.canvas.height);
    context.lineTo(context.canvas.width,0);
    context.lineTo(0,0)
    context.lineWidth = 20;
    context.strokeStyle = "#f1aec9"
    context.stroke()

    context.fillStyle = "#000000"

    let title="snap.scrap.repeat"
    let subtitle="Scrapbook Colour Challenge"
    let instructions = "Create a scrapbook layout inspired by the colour scheme..."
    let footer="Generated by snapscraprepeat.com"
    context.font = "bold 20px Montserrat"
    let space=context.canvas.width-context.measureText(title).width
    context.fillText(title,(space)/2,45)
    context.font = "bold 30px Montserrat"
    space=context.canvas.width-context.measureText(subtitle).width
    context.fillText(subtitle,(space)/2,80)
    context.font = "bold 15px Montserrat"
    space=context.canvas.width-context.measureText(instructions).width
    context.fillText(instructions,(space)/2,120)
    context.font = "bold 15px Montserrat"
    space=context.canvas.width-context.measureText(footer).width
    context.fillText(footer,(space)/2,context.canvas.height-30)
    outputImage.src = canvas.toDataURL()
  }
}
export default ColourChallengeCanvas;